import React from "react";
import CutomsRouter from "../router/laporan-bc.js";

const CustomsLayout = () => {
  return (
    <div
      className="kt-content kt-grid__item kt-grid__item--fluid"
      id="kt_content"
    >
      <CutomsRouter />
    </div>
  );
};

export default CustomsLayout;
